/* eslint-disable react/jsx-props-no-spreading */
import { Card as ChromaCard } from '@iag-packages/chroma-react/lib/components';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import THEME from 'theme';

interface StyleProps {
  justifyLeft?: boolean;
}

const CardWrapper = styled.div`
  .c-card {
    background-color: ${THEME.BACKGROUND.FLYBUYS};
    display: flex;
    ${(props: StyleProps) =>
      props.justifyLeft ? 'justify-content: left;' : 'justify-content: center;'}
`;

export const Card: FunctionComponent<{
  [x: string]: unknown;
  justifyLeft?: boolean;
}> = ({ justifyLeft, ...props }) => (
  <CardWrapper justifyLeft={justifyLeft}>
    <ChromaCard {...props} />
  </CardWrapper>
);

export default Card;
